import {M3uMedia, M3uPlaylist} from "../../lib/m3u";
import {IndexedDbFactory} from "../database/IndexedDbFactory";
import {ServiceError} from "../../hooks/fetch/types";

class PlaylistShortlistService {

    private static _instance: PlaylistShortlistService;

    private constructor() {
        //Private constructor to prevent direct instantiation
    }

    public static get Instance()
    {
        return this._instance || (this._instance = new this());
    }

    public async getPlaylist(): Promise<M3uPlaylist> {
        try {
            const data = await IndexedDbFactory.getInstance().getAll<M3uMedia>("playlist_shortlist");
            return new M3uPlaylist("Shortlist", data);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async add(channel: M3uMedia): Promise<void> {
        try {
            await IndexedDbFactory.getInstance().set("playlist_shortlist", channel, channel.name);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async remove(channel: M3uMedia): Promise<void> {
        try {
            await IndexedDbFactory.getInstance().delete("playlist_shortlist", channel.name!);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }
}

export const playlistShortlistService = PlaylistShortlistService.Instance;